import { Component } from '@theme/component';

const { animate, scroll } = window.Motion;

class ParallaxQuote extends Component {
  #animation = null;

  get start() {
    return this.getAttribute("data-start") || '0%';
  }

  get end() {
    return this.getAttribute("data-end") || '0%';
  }

  connectedCallback() {
    this.initAnimation();
  }

  initAnimation() {
    this.#animation = scroll(animate(this, {
      '--translate-y': [this.start, this.end],
    }), {
      target: this,
    });
  }
}

if (!customElements.get('parallax-quote')) {
  customElements.define('parallax-quote', ParallaxQuote);
}